window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled rejection (promise: ', event.promise, ', reason: ', event.reason, ').');

  if (window.Bugsnag) {

    // Check if the promise has a catch method
    if (event.promise && typeof event.promise.catch === 'function') {
      event.promise.catch((error) => {
        Bugsnag.notify(error, (bugnsagEvent) => {
          bugnsagEvent.severity = 'error';
          bugnsagEvent.context = 'Unhandled Promise Rejection';

          const reason = event.reason || {};
          bugnsagEvent.addMetadata('Unhandled Promise Rejection', {
            reason: reason.message || "No reason provided",
            stack: reason.stack || "No stack provided"
          });
        });
      });
    } else {

      // Fallback: if the promise does not have a catch method, we can still log the error
      const reason = event.reason || new Error("Unknown reason");
      Bugsnag.notify(reason, (bugnsagEvent) => {
        bugnsagEvent.severity = 'error';
        bugnsagEvent.context = 'Unhandled Promise Rejection';

        bugnsagEvent.addMetadata('Unhandled Promise Rejection', {
          reason: reason.message || "No reason provided",
          stack: reason.stack || "No stack provided"
        });
      });
    }
  }
});
